<template>
    <div class="collapse storefinderAccordion__panel storefinderAccordion__panel--visible" :class="{'storefinderAccordion__panel--open': showContent}">
      <div class="storefinderAccordion__panel__inner">
        <header class="storefinderAccordion__panelHeader interactive" @click="toggle">
          <IconArrow class="storefinderAccordion__arrow"/>
          <slot name="title"></slot>
        </header>

        <transition name="storefinder-collapse"
          @enter="enter"
          @after-enter="afterEnter"
          @leave="leave"
        >
          <div :class="{'item-content' : true, 'content--open': showContent}" v-show="showContent">
            <div class="content-container">
              <slot></slot>
            </div>
          </div>
        </transition>
      </div>
    </div>
</template>
<script>
    export default {
        name: 'StorefinderCollapse',
        data() {
            return {
                showContent: null,
            }
        },
        props:{
            expanded:  {
                type: Boolean,
                default: false
            },
            open: {
              type: Boolean,
              default: false
            },
            close: {
              type: Boolean,
              default: false
            },
        },
        mounted(){
            this.showContent = this.expanded;
        },
        methods: {
            enter(element) {
                const width = getComputedStyle(element).width;

                element.style.width = width;
                element.style.position = 'absolute';
                element.style.visibility = 'hidden';
                element.style.height = 'auto';

                const height = getComputedStyle(element).height;

                element.style.width = null;
                element.style.position = null;
                element.style.visibility = null;
                element.style.height = 0;

                // Force repaint to make sure the
                // animation is triggered correctly.
                getComputedStyle(element).height;

                // Trigger the animation.
                // We use `requestAnimationFrame` because we need
                // to make sure the browser has finished
                // painting after setting the `height`
                // to `0` in the line above.
                requestAnimationFrame(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
            leave(element) {
                const height = getComputedStyle(element).height;

                element.style.height = height;

                // Force repaint to make sure the
                // animation is triggered correctly.
                getComputedStyle(element).height;

                requestAnimationFrame(() => {
                    element.style.height = 0;
                });
            },
            toggle(){
                this.showContent = !this.showContent;
            }
        },
        watch:{
            expanded(expanded){
              console.log(expanded);
                this.showContent = expanded
            },
            open(isOpen){
              if(isOpen){
                this.showContent =  isOpen
              }
            },
            close(isClosed){
              if(!isClosed) {
                this.showContent = isClosed
              }
            },
        }
    }
</script>
